import { Injectable } from '@angular/core';
import { Restangular } from 'ngx-restangular';
import { CampaignInterface, PostCampaignInterface } from '../../interfaces/campaigns/campaign.interface';
import { AppSettings } from 'src/app/app.settings';

@Injectable({
  providedIn: 'root',
})
export class MarketingCampaignsService {
  constructor(
    private baseRestAngular: Restangular,
    private restAngular: Restangular
  ) {
    this.restAngular = this.getCustomRestAngular();
  }

  getCustomRestAngular() {
    return this.baseRestAngular.withConfig((RestangularConfigurer: any) => {
      RestangularConfigurer.setBaseUrl(AppSettings.getMarketingEndpoint());
    });
  }

  create(data: PostCampaignInterface): Promise<CampaignInterface | null> {
    return this.restAngular.one('campaigns').customPOST(data).toPromise();
  }

  getAll(): Promise<CampaignInterface[]> {
    return this.restAngular.one('campaigns').getList().toPromise();
  }

  runById(id: string): Promise<CampaignInterface> {
    return this.restAngular.one('campaigns', id).customPOST({}).toPromise();
  }

  updateById(id: string, data: any): Promise<any> {
    return this.restAngular.one('campaigns', id).customPUT(data).toPromise();
  }

  cloneById(id: string): Promise<any> {
    return this.restAngular.one('campaigns').one('clone', id).customPOST({}).toPromise();
  }

  getTargetCount(id: string): Promise<any> {
    return this.restAngular.one('campaigns', id).one('count').get().toPromise();
  }
}
